<template>
    <tbody>
        <side-by-side-row-lvl1 :row="row" :is_open="is_open" :colspan="colspan" @toggle="toggle"/>
        <side-by-side-row-lvl2-warning :row="row" :colspan="colspan" />
        <side-by-side-row-lvl3-campaign-name :row="row" :colspan="colspan" v-if="is_open" />
        <side-by-side-row-lvl4-order-detail :row="row" :colspan="colspan" v-if="is_open" @updated="$emit('updated')" />
    </tbody>
</template>

<script>
import SideBySideRowLvl1 from "./side-by-side-row-lvl1";
import SideBySideRowLvl2Warning from "./side-by-side-row-lvl2-warning";
import SideBySideRowLvl3CampaignName from "./side-by-side-row-lvl3-campaign-name";
import SideBySideRowLvl4OrderDetail from "./side-by-side-row-lvl4-order-detail";

export default {
    components: {
        SideBySideRowLvl4OrderDetail,
        SideBySideRowLvl3CampaignName, SideBySideRowLvl2Warning, SideBySideRowLvl1},
    props: [
        'row',
        'colspan'
    ],
    data() {
        return {
            is_open: false
        };
    },
    watch: {
        'row.right.is_locked'() {
            if (this.row.right.is_locked) {
                this.copyLeftToRight();
            }
        },
        'row.left': {
            deep: true,
            handler() {
                if (this.row.right.is_locked) {
                    this.copyLeftToRight();
                }
            }
        }
    },
    methods: {
        copyLeftToRight() {
            let newRight = JSON.parse(JSON.stringify(this.row.left));
            newRight.id = this.row.right.id;
            newRight.is_locked = true;
            newRight.multicarrier.rollover = this.row.right.multicarrier.rollover;
            newRight.singlecarrier.rollover = this.row.right.singlecarrier.rollover;
            newRight.fulfillment = this.row.right.fulfillment;

            this.row.right = newRight;
        },
        toggle() {
            this.is_open = !this.is_open;
        }
    }
}
</script>

<style>
td.locked {
    /*background: #f3f3f3;*/
}

td.locked input {
    pointer-events: none;
}

input.is-different {
    border-color: #dc3545;
    padding-right: calc(1.5em + .75rem);
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right calc(.375em + .1875rem) center;
    background-size: calc(.75em + .375rem) calc(.75em + .375rem);
}

input.is-different:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, .25);
}
</style>
